import { useTranslation } from 'next-i18next'
import { Icon } from '@captaincause/ui/Icon'
import { MINIDIFTMEN_NAMES, Minidiftman } from '@captaincause/ui/Minidiftman'

type Comment = {
  comment: string
  organization: string
}
interface CommentsProps {
  comments: Comment[]
}

export default function Comments({ comments }: CommentsProps) {
  const { t } = useTranslation('comments.block')

  return (
    <div className="relative hidden h-[376px] overflow-x-scroll bg-light-beige md:block">
      <div className="absolute left-[40px] flex flex-row gap-10 py-14">
        {comments.map((comment, index) => (
          <div
            key={comment.comment}
            className="flex min-w-[352px] flex-col justify-between gap-4 rounded-2xl border border-medium-gray p-6"
          >
            <div>
              <Icon icon="quote" className="mb-4" />
              <p className="line-clamp-3 text-xl font-semibold leading-8">
                {comment.comment}
              </p>
            </div>
            <div>
              <hr className="mb-4 h-[1px] border-none bg-medium-gray" />
              <div className="flex gap-4">
                <Minidiftman
                  variant={
                    MINIDIFTMEN_NAMES[
                      index >= MINIDIFTMEN_NAMES.length
                        ? index - MINIDIFTMEN_NAMES.length
                        : index
                    ]
                  }
                  className="h-8 w-8"
                  style={{ clipPath: 'circle(15.5px)' }}
                />
                <div className="flex flex-col text-dark-gray">
                  <span className="text-xs font-medium">
                    {t('comments-dift-target')}
                  </span>
                  <span className="text-sm font-medium">
                    {comment.organization}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
